/**
 * Main front end entry point.
 */

import "./utils.js";

import "./components/animations.js";
import "./components/carousels.js";
import "./components/cover-videos.js";
import "./components/lightboxes.js";
import "./components/mobile-menu.js";
import "./components/search-overlay.js";
import "./components/sticky-header.js";
import "./components/tabs.js";
import "./components/tooltips.js";
import "./components/trays.js";
import "./components/members-panel.js";

document.addEventListener("DOMContentLoaded", () => {
	// Add ID for the skip link to target
	if (document.querySelector("main")) {
		document.querySelector("main").id = "main";
	}

	// Debugging: Log the theme configuration if debugging is enabled
	if (window.bds_theme?.debug?.enabled) {
		console.log("BDS Theme Configuration:", bds_theme);
	}
});
